// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__EH5Ui","secondary":"styles_secondary__1duz8 styles_btn__EH5Ui","disabled":"styles_disabled__2JX2m styles_btn__EH5Ui"};